<template>
    <div>
        <atendimento-enfermagem :vacina="true" />
    </div>
</template>

<script>
import AtendimentoEnfermagem from '../enfermagem/AtendimentoEnfermagem.vue';

export default {
    components: { 
        AtendimentoEnfermagem
    },
}
</script>

